/**
 *	Rubin v16 (2026-08-08) – <rubin-seo-collapse> custom element.
 *	Visually limits long SEO texts to ~N lines (default 3) with a
 *	"Weiterlesen" / "Weniger anzeigen" toggle. The full text is always
 *	server-rendered; this element only measures and clips visually via a
 *	CSS max-height on the wrapper (never line-clamp on rich HTML).
 *	Modelled on the theme's native max-height component, extended with
 *	aria-expanded/aria-controls, label swapping and scroll-position
 *	preservation on collapse. Expansion is instant (theme-native pattern).
 */
if (!customElements.get('rubin-seo-collapse')) {
	class RubinSeoCollapse extends HTMLElement {
		connectedCallback() {
			this.inner = this.querySelector('.rubin-seo-collapse__inner');
			this.content = this.querySelector('.rubin-seo-collapse__content');
			this.toggle = this.querySelector('.rubin-seo-collapse__toggle');
			this.label = this.querySelector('.rubin-seo-collapse__label');
			if (!this.inner || !this.content || !this.toggle) return;
			this.lines = parseInt(this.dataset.lines || '3', 10);
			this.open = false;
			this.toggle.addEventListener('click', this.onToggle.bind(this));
			this.onResize = this.measure.bind(this);
			window.addEventListener('resize', this.onResize);
			window.addEventListener('load', this.onResize);
			this.measure();
		}
		disconnectedCallback() {
			window.removeEventListener('resize', this.onResize);
			window.removeEventListener('load', this.onResize);
		}
		lineHeight() {
			var probe = this.content.querySelector('p, li, div, span') || this.content;
			var cs = window.getComputedStyle(probe);
			var lh = parseFloat(cs.lineHeight);
			if (!lh || isNaN(lh)) lh = parseFloat(cs.fontSize) * 1.6 || 24;
			return lh;
		}
		measure() {
			var lh = this.lineHeight();
			var collapsedMax = Math.round(lh * this.lines);
			/* Clip via CSS custom property – only applied while :not(.is-open) */
			this.style.setProperty('--rubin-collapse-max', collapsedMax + 'px');
			var full = this.content.scrollHeight;
			/* Only activate when there is genuinely more than ~3 lines */
			if (full > collapsedMax + Math.round(lh * 0.6)) {
				this.classList.add('is-ready');
				this.toggle.hidden = false;
			} else {
				this.classList.remove('is-ready');
				this.classList.remove('is-open');
				this.toggle.hidden = true;
				this.open = false;
			}
		}
		onToggle() {
			var wasOpen = this.open;
			var toggleTopBefore = this.toggle.getBoundingClientRect().top;
			this.open = !this.open;
			this.classList.toggle('is-open', this.open);
			this.toggle.setAttribute('aria-expanded', this.open ? 'true' : 'false');
			if (this.label) {
				this.label.textContent = this.open
					? (this.toggle.dataset.labelLess || 'Weniger anzeigen')
					: (this.toggle.dataset.labelMore || 'Weiterlesen');
			}
			if (wasOpen && !this.open) {
				/* Collapsing a long text: keep the toggle at the same viewport
				   position so the visitor does not lose their place. */
				var diff = this.toggle.getBoundingClientRect().top - toggleTopBefore;
				if (Math.abs(diff) > 1) window.scrollBy(0, diff);
			}
		}
	}
	customElements.define('rubin-seo-collapse', RubinSeoCollapse);
}
